"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4610,2971],{

/***/ 46442:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/x-black.6f461ee7.svg","height":15,"width":15});

/***/ }),

/***/ 6860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AddToCartSection": function() { return /* reexport */ AddToCartSection; },
  "AddToCartSectionDesignB": function() { return /* reexport */ AddToCartSectionDesignB; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js
var chakra_ui_icons_esm = __webpack_require__(59876);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/alert/dist/chakra-ui-alert.esm.js
var chakra_ui_alert_esm = __webpack_require__(6886);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./src/intl-shim.tsx
var intl_shim = __webpack_require__(47355);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js + 1 modules
var add = __webpack_require__(50415);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(47930);
// EXTERNAL MODULE: ./src/providers/DatalayerProvider.tsx
var DatalayerProvider = __webpack_require__(51945);
// EXTERNAL MODULE: ./src/providers/TikTokPixelProvider.tsx + 45 modules
var TikTokPixelProvider = __webpack_require__(48841);
// EXTERNAL MODULE: ./src/components/atoms/index.ts + 6 modules
var atoms = __webpack_require__(23920);
// EXTERNAL MODULE: ./src/components/legacy/ShopProvider/context.ts
var context = __webpack_require__(61888);
// EXTERNAL MODULE: ./src/components/containers/index.ts + 1 modules
var containers = __webpack_require__(71547);
// EXTERNAL MODULE: ./src/components/organisms/AddToCartSection/styles.ts
var styles = __webpack_require__(60640);
;// CONCATENATED MODULE: ./src/components/organisms/AddToCartSection/stockHelpers.tsx




var isEqual = function(a, b) {
    return a && b && a.net.amount === b.net.amount && a.net.currency === b.net.currency && a.gross.amount === b.gross.amount && a.gross.currency === b.gross.currency;
};
/**
 * Renders formatted price for chosen variant or product.
 * Price ranges and discounts are additionally formatted available.
 */ var getProductPrice = function(productPricingRange, variantPricing) {
    if (variantPricing) {
        if (isEqual(variantPricing.priceUndiscounted, variantPricing.price)) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
                taxedMoney: {
                    gross: {
                        amount: (variantPricing === null || variantPricing === void 0 ? void 0 : (ref = variantPricing.price) === null || ref === void 0 ? void 0 : (ref1 = ref.gross) === null || ref1 === void 0 ? void 0 : ref1.amount) + (variantPricing === null || variantPricing === void 0 ? void 0 : (ref2 = variantPricing.borrowerFee) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.gross) === null || ref3 === void 0 ? void 0 : ref3.amount),
                        currency: variantPricing === null || variantPricing === void 0 ? void 0 : (ref4 = variantPricing.price) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.gross) === null || ref5 === void 0 ? void 0 : ref5.currency
                    },
                    net: {
                        amount: (variantPricing === null || variantPricing === void 0 ? void 0 : (ref6 = variantPricing.price) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.net) === null || ref7 === void 0 ? void 0 : ref7.amount) + (variantPricing === null || variantPricing === void 0 ? void 0 : (ref8 = variantPricing.borrowerFee) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.net) === null || ref9 === void 0 ? void 0 : ref9.amount),
                        currency: variantPricing === null || variantPricing === void 0 ? void 0 : (ref10 = variantPricing.price) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.net) === null || ref11 === void 0 ? void 0 : ref11.currency
                    }
                }
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* UndiscountedPrice */.ez, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
                        taxedMoney: variantPricing.priceUndiscounted
                    })
                }),
                "\xa0\xa0\xa0\xa0",
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
                    taxedMoney: variantPricing.price
                })
            ]
        });
    }
    if (!productPricingRange.priceRange) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    }
    var _priceRange = productPricingRange.priceRange, start = _priceRange.start, stop = _priceRange.stop;
    if (isEqual(start, stop)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
            taxedMoney: start
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
                taxedMoney: start
            }),
            " - ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
                taxedMoney: stop
            })
        ]
    });
};
var getAfterpayPrice = function(productPricingRange, variantPricing) {
    if (variantPricing) {
        if (isEqual(variantPricing.priceUndiscounted, variantPricing.price)) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
                taxedMoney: {
                    gross: {
                        amount: ((variantPricing === null || variantPricing === void 0 ? void 0 : (ref = variantPricing.price) === null || ref === void 0 ? void 0 : (ref1 = ref.gross) === null || ref1 === void 0 ? void 0 : ref1.amount) + (variantPricing === null || variantPricing === void 0 ? void 0 : (ref2 = variantPricing.borrowerFee) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.gross) === null || ref3 === void 0 ? void 0 : ref3.amount)) / 4,
                        currency: variantPricing === null || variantPricing === void 0 ? void 0 : (ref4 = variantPricing.price) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.gross) === null || ref5 === void 0 ? void 0 : ref5.currency
                    },
                    net: {
                        amount: ((variantPricing === null || variantPricing === void 0 ? void 0 : (ref6 = variantPricing.price) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.net) === null || ref7 === void 0 ? void 0 : ref7.amount) + (variantPricing === null || variantPricing === void 0 ? void 0 : (ref8 = variantPricing.borrowerFee) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.net) === null || ref9 === void 0 ? void 0 : ref9.amount)) / 4,
                        currency: variantPricing === null || variantPricing === void 0 ? void 0 : (ref10 = variantPricing.price) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.net) === null || ref11 === void 0 ? void 0 : ref11.currency
                    }
                }
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* UndiscountedPrice */.ez, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
                        taxedMoney: variantPricing.priceUndiscounted
                    })
                }),
                "\xa0\xa0\xa0\xa0",
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
                    taxedMoney: variantPricing.price
                })
            ]
        });
    }
    if (!productPricingRange.priceRange) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    }
    var _priceRange = productPricingRange.priceRange, start = _priceRange.start, stop = _priceRange.stop;
    if (isEqual(start, stop)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
            taxedMoney: start
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
                taxedMoney: start
            }),
            " - ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
                taxedMoney: stop
            })
        ]
    });
};
var canAddToCart = function(items, isAvailableForPurchase, variantId, quantity) {
    // Only allow one item in cart
    if (items === null || items === void 0 ? void 0 : items.length) return false;
    return isAvailableForPurchase && quantity > 0 && !!variantId;
};

;// CONCATENATED MODULE: ./src/components/molecules/ProductVariantSelector/ProductVariantSelector.tsx





var ProductVariantSelector = function(param) {
    var productVariants = param.productVariants, setVariantId = param.setVariantId, variantId = param.variantId;
    var ref;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
        width: "100%",
        alignItems: "left",
        mb: {
            base: 6,
            md: 2
        },
        children: (ref = productVariants === null || productVariants === void 0 ? void 0 : productVariants.sort(function(a, b) {
            return ((a === null || a === void 0 ? void 0 : a.rentalDays) || 0) - ((b === null || b === void 0 ? void 0 : b.rentalDays) || 0);
        })) === null || ref === void 0 ? void 0 : ref.map(function(pv) {
            // @ts-expect-error
            return (pv === null || pv === void 0 ? void 0 : pv.disabled) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                direction: "row",
                alignItems: "center",
                height: "30px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        width: "1.5rem",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Checkbox, {
                            name: (pv === null || pv === void 0 ? void 0 : pv.name) || "",
                            checked: (pv === null || pv === void 0 ? void 0 : pv.id) === variantId,
                            onChange: function() {
                                return setVariantId((pv === null || pv === void 0 ? void 0 : pv.id) || "");
                            },
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                        textAlign: "left",
                        style: {
                            fontSize: "1rem",
                            color: "red"
                        },
                        children: [
                            (pv === null || pv === void 0 ? void 0 : pv.name) || "",
                            " (",
                            "Unavailable for this date",
                            ") "
                        ]
                    })
                ]
            }, pv === null || pv === void 0 ? void 0 : pv.id) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Flex */.kC, {
                direction: "row",
                alignItems: "center",
                height: "30px",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(atoms.Checkbox, {
                    name: (pv === null || pv === void 0 ? void 0 : pv.name) || "",
                    checked: (pv === null || pv === void 0 ? void 0 : pv.id) === variantId,
                    onChange: function() {
                        return setVariantId((pv === null || pv === void 0 ? void 0 : pv.id) || "");
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            mr: 2,
                            whiteSpace: "nowrap",
                            children: (pv === null || pv === void 0 ? void 0 : pv.name) || ""
                        }),
                        (pv === null || pv === void 0 ? void 0 : pv.id) !== variantId && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                            children: [
                                " (",
                                getProductPrice(null, pv === null || pv === void 0 ? void 0 : pv.pricing),
                                ")"
                            ]
                        })
                    ]
                })
            }, pv === null || pv === void 0 ? void 0 : pv.id);
        })
    });
};
/* harmony default export */ var ProductVariantSelector_ProductVariantSelector = (ProductVariantSelector);

// EXTERNAL MODULE: ./src/components/organisms/index.ts + 9 modules
var organisms = __webpack_require__(14254);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
// EXTERNAL MODULE: ./src/utils/base64.ts
var base64 = __webpack_require__(43521);
// EXTERNAL MODULE: ./src/utils/getAttributeValue.ts
var getAttributeValue = __webpack_require__(6360);
;// CONCATENATED MODULE: ./src/images/afterpay.svg
/* harmony default export */ var afterpay = ({"src":"/_next/static/media/afterpay.114534b1.svg","height":50,"width":100});
;// CONCATENATED MODULE: ./src/components/organisms/AddToCartSection/AddToCartSection.tsx
/* eslint-disable import/no-unresolved */ 


























var processProductVariants = function(productVariants, startDate, bookedDates) {
    if (!productVariants || productVariants.length === 0 || (0,lodash.isEmpty)(productVariants)) return [];
    var productVariantsModified = productVariants.map(function(param) {
        var id = param.id, sku = param.sku, name = param.name, rentalDays = param.rentalDays, quantityAvailable = param.quantityAvailable, images = param.images, pricing = param.pricing, attributes = param.attributes;
        var variantEndDate = null;
        var disabled = false;
        if (startDate) {
            variantEndDate = (0,addDays/* default */.Z)(startDate, rentalDays - 1);
            var varientEndDateString = variantEndDate === null || variantEndDate === void 0 ? void 0 : variantEndDate.toString();
            disabled = typeof varientEndDateString === "string" && bookedDates.some(function(date) {
                return date.toString() === varientEndDateString;
            });
        }
        if (rentalDays === 365) disabled = false;
        return {
            __typename: "ProductVariant",
            id: id,
            sku: sku,
            name: name,
            rentalDays: rentalDays,
            quantityAvailable: quantityAvailable,
            images: images,
            pricing: pricing,
            attributes: attributes,
            disabled: disabled
        };
    });
    return productVariantsModified;
};
var AddToCartSection = function(param) {
    var availableForPurchase = param.availableForPurchase, isAvailableForPurchase = param.isAvailableForPurchase, items = param.items, name = param.name, designer = param.designer, designerSlug = param.designerSlug, bookedDates = param.bookedDates, product = param.product, productPricing = param.productPricing, productVariants = param.productVariants, productSeoDescription = param.productSeoDescription, productAttributes = param.productAttributes, onSubmit = param.onSubmit, setVariantId = param.setVariantId, variantId = param.variantId, mobile = param.mobile, removeItem = param.removeItem, productBookingsLoading = param.productBookingsLoading, _loaded = param.loaded, loaded = _loaded === void 0 ? false : _loaded, isAvailableForRent = param.isAvailableForRent, _isSamedayEligible = param.isSamedayEligible, isSamedayEligible = _isSamedayEligible === void 0 ? false : _isSamedayEligible, _canPickupToday = param.canPickupToday, canPickupToday = _canPickupToday === void 0 ? true : _canPickupToday;
    var ref;
    var intl = (0,intl_shim/* useIntl */.YB)();
    var ref1 = (0,TikTokPixelProvider/* useTikTokPixelContext */.n)(), clientIpAddress = ref1.clientIpAddress, track = ref1.track;
    var push = (0,DatalayerProvider/* useDatalayer */.t)().push;
    var currency = (0,react.useContext)(context/* ShopContext */.I).currency;
    var ref2 = (0,react.useState)(false), submitting = ref2[0], setSubmitting = ref2[1];
    var selectedVariant = productVariants === null || productVariants === void 0 ? void 0 : productVariants.find(function(pv) {
        return (pv === null || pv === void 0 ? void 0 : pv.id) === variantId;
    });
    var rentalPeriod = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.rentalDays;
    var preparationDays = product === null || product === void 0 ? void 0 : (ref = product.resource) === null || ref === void 0 ? void 0 : ref.preparationDays;
    var disabledDaysSortedAsc = bookedDates.sort(function(objA, objB) {
        return Number(objA) - Number(objB);
    });
    var today = new Date();
    // This is for the date where you can book the item
    var latestDate = !(0,lodash.isEmpty)(bookedDates) ? disabledDaysSortedAsc[disabledDaysSortedAsc.length - 1] : (0,add/* default */.Z)(today, {
        days: 1
    });
    latestDate = (0,add/* default */.Z)(latestDate, {
        days: preparationDays
    });
    // Reset the date to 12am
    latestDate.setHours(12, 0, 0, 0);
    var noPurchaseAvailable = !isAvailableForPurchase && !availableForPurchase;
    var purchaseAvailableDate = !isAvailableForPurchase && availableForPurchase && Date.parse(availableForPurchase);
    var outOfStock = Number(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.quantityAvailable) <= 0;
    var maximumShippingDays = (0,lodash.get)(product, "shippingMethods[0].maximumDeliveryDays", 0);
    var minimumShippingDays = (0,lodash.get)(product, "shippingMethods[0].minimumDeliveryDays", 0);
    var disableButton = // eslint-disable-next-line strict-null-checks/all
    !canAddToCart(items || [], !!isAvailableForPurchase, variantId, 1) || outOfStock;
    var renderErrorMessage = function(message, testingContextId) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ErrorMessage */.Bc, {
            "data-test": "stockErrorMessage",
            "data-test-id": testingContextId,
            children: message
        });
    };
    var router = (0,next_router.useRouter)();
    var deliveryDate = router.query.deliveryDate;
    var useDateFilter = false;
    var ref3 = (0,react.useState)(deliveryDate && typeof deliveryDate === "string" ? new Date(deliveryDate) : null), startDate = ref3[0], setStartDate = ref3[1];
    if (deliveryDate) useDateFilter = true;
    startDate === null || startDate === void 0 ? void 0 : startDate.setHours(12, 0, 0, 0);
    if (deliveryDate && new Date(deliveryDate.toString()).getTime() < new Date().getTime()) useDateFilter = false;
    if (useDateFilter && startDate && startDate.getTime() > latestDate.getTime()) latestDate = startDate;
    var isLatestPastStartDate = startDate && latestDate.getTime() > startDate.getTime();
    var productVariantsModified = processProductVariants(productVariants, startDate, bookedDates);
    var localeDateString = startDate === null || startDate === void 0 ? void 0 : startDate.toLocaleDateString("en-GB");
    var productSize = react.useMemo(function() {
        var ref;
        var productSizeStr = "";
        var productSizeAttr = productAttributes && (productAttributes === null || productAttributes === void 0 ? void 0 : productAttributes.length) > 0 && productAttributes.find(function(attr) {
            return attr.attribute.name === "Size";
        });
        if (productSizeAttr && (productSizeAttr === null || productSizeAttr === void 0 ? void 0 : (ref = productSizeAttr.values) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            productSizeStr = productSizeAttr.values.map(function(value) {
                return value === null || value === void 0 ? void 0 : value.name;
            }).join(", ");
        }
        return productSizeStr;
    }, [
        productAttributes
    ]);
    var hasIncompleteOrder = !submitting && items && items.length;
    var cartWarning = hasIncompleteOrder ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_alert_esm/* Alert */.bZ, {
                status: "error",
                paddingY: "16px",
                paddingX: "12px",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                    display: "flex",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            marginBottom: "5px",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* AlertIcon */.zM, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_alert_esm/* AlertIcon */.zM, {})
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_alert_esm/* AlertTitle */.Cd, {
                                    children: "Only one item can be ordered at a time."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_alert_esm/* AlertDescription */.X, {
                            children: "Complete the order for the ".concat(name, " or remove it from your bag.")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(atoms.ButtonBoxLink, {
                style: {
                    fontSize: "1rem",
                    lineHeight: "1.1rem",
                    marginTop: "10px",
                    marginBottom: "10px",
                    width: "100%",
                    height: "56px",
                    gap: "5px",
                    background: "black",
                    color: "white"
                },
                href: paths/* paths.checkout */.H.checkout,
                testingContext: "complete-current-order-btn",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* BagIcon */.Ln, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Icon, {
                            name: "cart",
                            size: 24,
                            viewboxX: 32,
                            viewboxY: 32
                        })
                    }),
                    "COMPLETE ORDER"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(atoms.Button, {
                style: {
                    whiteSpace: "normal",
                    height: "40px",
                    padding: "8px",
                    fontSize: "1rem",
                    lineHeight: "1.1rem",
                    textTransform: "unset",
                    marginBottom: "10px",
                    width: "100%",
                    gap: "5px"
                },
                testingContext: "clearCartButton",
                onClick: function() {
                    return removeItem(items[0].variant.id);
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* RemoveIcon */.HF, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Icon, {
                            name: "trash",
                            size: 24,
                            viewboxX: 32,
                            viewboxY: 32
                        })
                    }),
                    "REMOVE FROM BAG"
                ]
            })
        ]
    }) : "";
    var isRental = (rentalPeriod || 0) < 365;
    var pricePrefix = isRental ? "Rental Price " : "Purchase Price ";
    var dateSelectText = "RENT NOW";
    if (outOfStock) dateSelectText = "OUT OF STOCK";
    if (!isRental) dateSelectText = "BUY NOW";
    var changeDateText = mobile ? "CHANGE DELIVERY DATE" : "Change delivery date";
    var deliveryText = isRental ? "Renting for a delivery date of ".concat(localeDateString) : "Purchasing for a delivery date of ".concat(latestDate.toLocaleDateString("en-GB"));
    var trackAddToCart = function() {
        if (product) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            var decodedProductId = (0,base64/* decodeBase64Id */.n)(product.id);
            var designerAttribute = product.attributes.find(function(attr) {
                return attr.attribute.name === "Designer";
            });
            var pricing = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.pricing) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.gross;
            var borrowerFee = (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref2 = selectedVariant.pricing) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.borrowerFee) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.gross) === null || ref4 === void 0 ? void 0 : ref4.amount) || 0;
            var price = ((pricing === null || pricing === void 0 ? void 0 : pricing.amount) || 0) + borrowerFee;
            var brand = (designerAttribute === null || designerAttribute === void 0 ? void 0 : (ref5 = designerAttribute.values) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.name) || "";
            track("AddToCart", {
                contents: [
                    {
                        content_id: decodedProductId,
                        content_name: product.name,
                        content_type: "product",
                        price: price,
                        brand: brand,
                        quantity: 1
                    }, 
                ],
                value: price,
                currency: (pricing === null || pricing === void 0 ? void 0 : pricing.currency) || "AUD",
                description: clientIpAddress
            });
        }
    };
    var pushToDataLayer = function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var ref6;
        var selectedVariantPrice = (ref6 = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.pricing) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.gross) === null || ref2 === void 0 ? void 0 : ref2.amount) !== null && ref6 !== void 0 ? ref6 : 0;
        var ref7;
        var borrowerFee = (ref7 = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref3 = selectedVariant.pricing) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.borrowerFee) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.gross) === null || ref5 === void 0 ? void 0 : ref5.amount) !== null && ref7 !== void 0 ? ref7 : 0;
        var totalPrice = selectedVariantPrice + borrowerFee;
        if (product && selectedVariant && !!totalPrice) {
            var ref8;
            var ref9;
            push({
                event: "add_to_cart",
                ecommerce: {
                    currency: currency,
                    value: totalPrice,
                    items: [
                        {
                            item_id: (0,base64/* decodeBase64Id */.n)(product.id),
                            item_brand: (0,getAttributeValue/* getAttributeValue */.k)("designer", product.attributes),
                            item_category: (ref9 = (ref8 = product.category) === null || ref8 === void 0 ? void 0 : ref8.name) !== null && ref9 !== void 0 ? ref9 : "",
                            item_name: product.name,
                            item_variant: "Size ".concat((0,getAttributeValue/* getAttributeValue */.k)("size", product.attributes)),
                            price: totalPrice,
                            quantity: 1
                        }, 
                    ]
                }
            });
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* AddToCartSelection */.aH, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* DesignerHeader */.$c, {
                "data-test": "designer",
                href: "/designers/".concat(designerSlug.endsWith("-hire") ? designerSlug : designerSlug.concat("-hire")),
                children: [
                    designer,
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* ChevronRightIcon */.XC, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ProductNameHeader */.ox, {
                "data-test": "productName",
                children: name
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ProductSizeHeader */.vH, {
                "data-test": "productSize",
                children: "Size ".concat(productSize)
            }),
            isAvailableForRent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* ProductPricing */.go, {
                        children: [
                            pricePrefix,
                            !!productPricing && getProductPrice(productPricing, selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.pricing)
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* AfterPay */.C7, {
                        children: [
                            "or 4 payments of",
                            " ",
                            !!productPricing && getAfterpayPrice(productPricing, selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.pricing),
                            " ",
                            "with",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                src: afterpay.src,
                                width: 100,
                                height: 35,
                                alt: "afterpay-logo"
                            })
                        ]
                    })
                ]
            }),
            useDateFilter && isRental && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* DeliveryDate */.PP, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Icon, {
                        name: "tick_circle",
                        size: 20,
                        viewboxX: 16,
                        viewboxY: 16
                    }),
                    deliveryText
                ]
            }),
            useDateFilter && !isRental && !isLatestPastStartDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* DeliveryDate */.PP, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Icon, {
                        name: "tick_circle",
                        size: 20,
                        viewboxX: 16,
                        viewboxY: 16
                    }),
                    deliveryText
                ]
            }),
            noPurchaseAvailable && isAvailableForRent && renderErrorMessage(intl.formatMessage(src_intl/* commonMessages.noPurchaseAvailable */.i4.noPurchaseAvailable), "notAvailable"),
            !isAvailableForRent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                style: {
                    textAlign: "left",
                    marginBottom: "10px"
                },
                children: "The owner of this item hasn't set a price yet, Click Enquire Now and they'll be sent a message, we'll then let you know when the item is available."
            }),
            purchaseAvailableDate && renderErrorMessage(intl.formatMessage(src_intl/* commonMessages.purchaseAvailableOn */.i4.purchaseAvailableOn), "timeRestrictedAvailability"),
            !mobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ProductDescription */.vI, {
                        "data-test": "productDescription",
                        children: productSeoDescription
                    }),
                    !hasIncompleteOrder && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductVariantSelector_ProductVariantSelector, {
                                productVariants: productVariantsModified,
                                variantId: variantId,
                                setVariantId: setVariantId
                            }),
                            !productBookingsLoading && loaded && isAvailableForRent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* VariantPicker */.fH, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* InputDatePicker */.$x, {
                                    disabledDays: (0,_to_consumable_array/* default */.Z)(bookedDates).concat([
                                        !isSamedayEligible ? {
                                            before: dayjs_min_default()().startOf("date").add(2, "day").toDate()
                                        } : canPickupToday ? {
                                            before: dayjs_min_default()().startOf("date").toDate()
                                        } : {
                                            before: dayjs_min_default()().startOf("date").add(1, "day").toDate()
                                        }, 
                                    ]),
                                    dateFilterStartDate: useDateFilter ? startDate : undefined,
                                    daysRange: rentalPeriod || 3,
                                    disabled: !rentalPeriod || disableButton,
                                    onSubmit: function() {
                                        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                                            var from, to;
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        from = param.from, to = param.to;
                                                        setSubmitting(true);
                                                        trackAddToCart();
                                                        pushToDataLayer();
                                                        return [
                                                            4,
                                                            onSubmit({
                                                                variantId: variantId,
                                                                quantity: 1,
                                                                rentalPeriod: rentalPeriod,
                                                                bookedRange: {
                                                                    from: from,
                                                                    to: to
                                                                }
                                                            })
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(_) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(),
                                    defaultText: dateSelectText,
                                    sleepTime: 500,
                                    isPurchase: !isRental,
                                    preparationDays: preparationDays || 3,
                                    maximumShippingDays: maximumShippingDays,
                                    minimumShippingDays: minimumShippingDays,
                                    samedayPickupEnabled: isSamedayEligible,
                                    canPickupToday: canPickupToday
                                })
                            })
                        ]
                    }),
                    !isAvailableForRent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                        bgColor: "transparent",
                        onClick: function() {
                            router.push((0,react_router/* generatePath */.Gn)(paths/* paths.enquire */.H.enquire, {
                                slug: product === null || product === void 0 ? void 0 : product.slug
                            }));
                        },
                        sx: {
                            fontSize: "1rem",
                            fontWeight: "bold"
                        },
                        children: "ENQUIRE NOW"
                    }),
                    !hasIncompleteOrder && deliveryDate && useDateFilter && isRental && !productBookingsLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ChangeDatePicker */.dy, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* InputDatePicker */.$x, {
                            disabledDays: (0,_to_consumable_array/* default */.Z)(bookedDates).concat([
                                !isSamedayEligible ? {
                                    before: dayjs_min_default()().startOf("date").add(2, "day").toDate()
                                } : canPickupToday ? {
                                    before: dayjs_min_default()().startOf("date").toDate()
                                } : {
                                    before: dayjs_min_default()().startOf("date").add(1, "day").toDate()
                                }, 
                            ]),
                            daysRange: rentalPeriod || 3,
                            disabled: !rentalPeriod || disableButton,
                            onSubmit: function(param) {
                                var from = param.from;
                                setStartDate(from);
                            },
                            defaultText: changeDateText,
                            sleepTime: 500,
                            preparationDays: preparationDays || 3,
                            maximumShippingDays: maximumShippingDays,
                            minimumShippingDays: minimumShippingDays,
                            samedayPickupEnabled: isSamedayEligible,
                            canPickupToday: canPickupToday
                        })
                    }),
                    cartWarning
                ]
            }),
            mobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    !hasIncompleteOrder && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* PickBoxes */.qA, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                                    columns: {
                                        base: 1,
                                        sm: 2
                                    },
                                    spacing: 2,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                        paddingLeft: 2,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductVariantSelector_ProductVariantSelector, {
                                            productVariants: productVariantsModified,
                                            variantId: variantId,
                                            setVariantId: setVariantId
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* RentButton */.FM, {
                                        children: !productBookingsLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* InputDatePicker */.$x, {
                                            disabledDays: (0,_to_consumable_array/* default */.Z)(bookedDates).concat([
                                                !isSamedayEligible ? {
                                                    before: dayjs_min_default()().startOf("date").add(2, "day").toDate()
                                                } : canPickupToday ? {
                                                    before: dayjs_min_default()().startOf("date").toDate()
                                                } : {
                                                    before: dayjs_min_default()().startOf("date").add(1, "day").toDate()
                                                }, 
                                            ]),
                                            dateFilterStartDate: useDateFilter ? startDate : undefined,
                                            daysRange: rentalPeriod || 3,
                                            disabled: !rentalPeriod || disableButton,
                                            onSubmit: function() {
                                                var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                                                    var from, to;
                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                from = param.from, to = param.to;
                                                                setSubmitting(true);
                                                                trackAddToCart();
                                                                pushToDataLayer();
                                                                return [
                                                                    4,
                                                                    onSubmit({
                                                                        variantId: variantId,
                                                                        quantity: 1,
                                                                        rentalPeriod: rentalPeriod,
                                                                        bookedRange: {
                                                                            from: from,
                                                                            to: to
                                                                        }
                                                                    })
                                                                ];
                                                            case 1:
                                                                _state.sent();
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                });
                                                return function(_) {
                                                    return _ref.apply(this, arguments);
                                                };
                                            }(),
                                            defaultText: dateSelectText,
                                            sleepTime: 500,
                                            isPurchase: !isRental,
                                            preparationDays: preparationDays || 3,
                                            maximumShippingDays: maximumShippingDays,
                                            minimumShippingDays: minimumShippingDays,
                                            samedayPickupEnabled: isSamedayEligible,
                                            canPickupToday: canPickupToday
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* RentButton */.FM, {
                                        children: !hasIncompleteOrder && deliveryDate && useDateFilter && isRental && !productBookingsLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                            display: "flex",
                                            marginTop: "16px",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* InputDatePicker */.$x, {
                                                disabledDays: (0,_to_consumable_array/* default */.Z)(bookedDates).concat([
                                                    !isSamedayEligible ? {
                                                        before: dayjs_min_default()().startOf("date").add(2, "day").toDate()
                                                    } : canPickupToday ? {
                                                        before: dayjs_min_default()().startOf("date").toDate()
                                                    } : {
                                                        before: dayjs_min_default()().startOf("date").add(1, "day").toDate()
                                                    }, 
                                                ]),
                                                daysRange: rentalPeriod || 3,
                                                disabled: !rentalPeriod,
                                                onSubmit: function() {
                                                    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                                                        var from, to;
                                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    from = param.from, to = param.to;
                                                                    setSubmitting(true);
                                                                    trackAddToCart();
                                                                    pushToDataLayer();
                                                                    return [
                                                                        4,
                                                                        onSubmit({
                                                                            variantId: variantId,
                                                                            quantity: 1,
                                                                            rentalPeriod: rentalPeriod,
                                                                            bookedRange: {
                                                                                from: from,
                                                                                to: to
                                                                            }
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    _state.sent();
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                    return function(_) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }(),
                                                defaultText: changeDateText,
                                                sleepTime: 500,
                                                preparationDays: preparationDays || 3,
                                                maximumShippingDays: maximumShippingDays,
                                                minimumShippingDays: minimumShippingDays,
                                                samedayPickupEnabled: isSamedayEligible,
                                                canPickupToday: canPickupToday
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    cartWarning,
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {})
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/globalStyles/index.ts + 2 modules
var globalStyles = __webpack_require__(63319);
;// CONCATENATED MODULE: ./src/utils/format-money.ts
var formatMoney = function(amount, currency) {
    return amount.toLocaleString("en-AU", {
        style: "currency",
        currency: currency || "AUD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js
var chakra_ui_system_esm = __webpack_require__(46052);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameDay/index.js + 1 modules
var isSameDay = __webpack_require__(81743);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(42699);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isBefore/index.js
var isBefore = __webpack_require__(313);
// EXTERNAL MODULE: ./node_modules/lodash/clone.js
var clone = __webpack_require__(66678);
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./src/hooks/useFirstAvailableDate.ts
var useFirstAvailableDate = __webpack_require__(78166);
// EXTERNAL MODULE: ./src/components/organisms/Overlay/index.ts + 2 modules
var Overlay = __webpack_require__(92971);
// EXTERNAL MODULE: ./node_modules/react-day-picker/lib/react-day-picker.min.js
var react_day_picker_min = __webpack_require__(63738);
var react_day_picker_min_default = /*#__PURE__*/__webpack_require__.n(react_day_picker_min);
// EXTERNAL MODULE: ./node_modules/react-day-picker/lib/style.css
var style = __webpack_require__(47318);
;// CONCATENATED MODULE: ./src/components/organisms/AddToCartSection/AddToCartSectionDesignB/CheckoutButton/CheckoutDatePicker.tsx






var CheckoutDatePicker = function(param) {
    var disabledDays = param.disabledDays, range = param.range, handleOnDayClicked = param.handleOnDayClicked, firstAvailableDate = param.firstAvailableDate, _isSamedayEligible = param.isSamedayEligible, isSamedayEligible = _isSamedayEligible === void 0 ? false : _isSamedayEligible, _canPickupToday = param.canPickupToday, canPickupToday = _canPickupToday === void 0 ? false : _canPickupToday;
    var ref = range || {}, from = ref.from, to = ref.to;
    firstAvailableDate = firstAvailableDate || new Date();
    var toDate = new Date();
    toDate.setFullYear(firstAvailableDate.getFullYear() + 1);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        sx: {
            ".DayPicker-Caption": {
                textAlign: "center",
                borderBottom: "1.5px solid black",
                paddingBottom: "1rem"
            },
            ".DayPicker-NavButton--prev": {
                left: "1.5rem"
            },
            ".DayPicker": {
                margin: "auto"
            },
            ".DayPicker-Month": {
                borderCollapse: "unset",
                borderSpacing: "8px"
            },
            ".DayPicker-Day--selected": {
                backgroundColor: "black !important"
            },
            "@media screen and (min-width: 30rem)": {
                ".DayPicker-Day": {
                    padding: "0.7rem"
                },
                ".DayPicker-Month": {
                    borderCollapse: "unset",
                    borderSpacing: "24px 14px"
                }
            }
        },
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((react_day_picker_min_default()), {
                numberOfMonths: 1,
                disabledDays: disabledDays,
                selectedDays: [
                    from,
                    {
                        from: from,
                        to: to
                    }
                ],
                onDayClick: handleOnDayClicked,
                initialMonth: firstAvailableDate,
                toMonth: toDate
            }),
            isSamedayEligible && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                sx: {
                    alignSelf: "center",
                    fontSize: "16px",
                    fontWeight: "800",
                    marginBottom: "1rem",
                    maxWidth: "fit-content"
                },
                type: "button",
                onClick: function() {
                    if (canPickupToday) {
                        // format to resemble date picker value
                        var today = dayjs_min_default()().hour(12).minute(0).second(0).millisecond(0).toDate();
                        handleOnDayClicked(today);
                    } else {
                        var tomorrow = dayjs_min_default()().add(1, "day").hour(12).minute(0).second(0).millisecond(0).toDate();
                        handleOnDayClicked(tomorrow);
                    }
                },
                children: canPickupToday ? "PICKUP TODAY" : "PICKUP TOMORROW"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/components/organisms/AddToCartSection/AddToCartSectionDesignB/CheckoutButton/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      font-size: ",
        ";\n      margin-bottom: 16px;\n      padding: 12px;\n      background-color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var PurchaseDeliveryDate = emotion_styled_browser_esm/* default.h4 */.Z.h4(_templateObject1(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, colors = theme.colors;
    return (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), typography.smallFontSize, colors.successGreen);
});

// EXTERNAL MODULE: ./src/images/x-black.svg
var x_black = __webpack_require__(46442);
;// CONCATENATED MODULE: ./src/components/organisms/AddToCartSection/AddToCartSectionDesignB/CheckoutButton/index.tsx












var CheckoutButton = function(param) {
    var _disabledDays = param.disabledDays, disabledDays = _disabledDays === void 0 ? [] : _disabledDays, _daysRange = param.daysRange, daysRange = _daysRange === void 0 ? 3 : _daysRange, onSubmit = param.onSubmit, disabled = param.disabled, _defaultText = param.defaultText, defaultText = _defaultText === void 0 ? "Date required" : _defaultText, _sleepTime = param.sleepTime, sleepTime = _sleepTime === void 0 ? 0 : _sleepTime, dateFilterStartDate = param.dateFilterStartDate, isPurchase = param.isPurchase, preparationDays = param.preparationDays, maximumShippingDays = param.maximumShippingDays, minimumShippingDays = param.minimumShippingDays, _samedayPickupEnabled = param.samedayPickupEnabled, samedayPickupEnabled = _samedayPickupEnabled === void 0 ? false : _samedayPickupEnabled, _canPickupToday = param.canPickupToday, canPickupToday = _canPickupToday === void 0 ? false : _canPickupToday;
    var headerStyles = (0,chakra_ui_system_esm/* useStyleConfig */.mq)("h3");
    var ref = (0,react.useMemo)(function() {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        var validRange = daysRange - 1 > 0 ? daysRange - 1 : 0;
        // eslint-disable-next-line @typescript-eslint/no-shadow
        var startDate = dateFilterStartDate || new Date();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        var endDate = (0,add/* default */.Z)(startDate, {
            days: validRange
        });
        return {
            startDate: startDate,
            endDate: endDate,
            validRange: validRange
        };
    }, [
        daysRange,
        dateFilterStartDate
    ]), startDate = ref.startDate, endDate = ref.endDate, validRange = ref.validRange;
    var ref1 = (0,useFirstAvailableDate/* useFirstAvailableDate */.N)({
        disabledDays: disabledDays,
        preparationDays: preparationDays,
        maximumShippingDays: maximumShippingDays,
        minimumShippingDays: minimumShippingDays,
        validRange: validRange
    }), firstAvailableDate = ref1.firstAvailableDate, firstAvailablePurchaseDateEnd = ref1.firstAvailablePurchaseDateEnd, isDisabledPurchase = ref1.isDisabledPurchase;
    var ref2 = (0,react.useState)(false), isOpen = ref2[0], setIsOpen = ref2[1];
    var ref3 = (0,react.useState)({}), range = ref3[0], setRange = ref3[1];
    var dateFilterRange = {
        from: startDate,
        to: endDate
    };
    var disabledDaysSortedAsc = clone_default()(disabledDays).sort(function(objA, objB) {
        return Number(objA) - Number(objB);
    });
    var latestDate = disabledDaysSortedAsc[disabledDaysSortedAsc.length - 2];
    var before = disabledDaysSortedAsc[disabledDaysSortedAsc.length - 1];
    latestDate = (0,add/* default */.Z)(latestDate, {
        days: preparationDays
    });
    latestDate.setHours(12, 0, 0, 0);
    var purchase = (0,add/* default */.Z)(latestDate, {
        days: validRange
    });
    purchase.setHours(12, 0, 0, 0);
    var today = (0,add/* default */.Z)(before.before, {
        days: 1
    });
    today = (0,add/* default */.Z)(today, {
        days: preparationDays
    });
    today.setHours(12, 0, 0, 0);
    var isLatestPastToday = latestDate.getTime() > today.getTime();
    var purchaseRange = {
        from: firstAvailableDate,
        to: firstAvailablePurchaseDateEnd
    };
    var handleOnDayClicked = function(date) {
        var selectedRange = {
            from: date,
            to: (0,add/* default */.Z)(date, {
                days: validRange
            })
        };
        if (!disabledDays.find(function(d) {
            return (0,isSameDay/* default */.Z)(d, selectedRange.to) || (0,isSameDay/* default */.Z)(d, selectedRange.from) || (0,isAfter/* default */.Z)(d, selectedRange.from) && (0,isBefore/* default */.Z)(d, selectedRange.to) || (d === null || d === void 0 ? void 0 : d.before) && (0,isAfter/* default */.Z)(d.before, selectedRange.from) // d.before is appended on the AddToCartSection
            ;
        })) {
            setRange(selectedRange);
            setTimeout(function() {
                onSubmit(selectedRange);
                setIsOpen(false);
            }, sleepTime);
        }
    };
    var handleSkipDatePicker = function() {
        if (!disabledDays.find(function(d) {
            return (0,isSameDay/* default */.Z)(d, dateFilterRange.to) || (0,isSameDay/* default */.Z)(d, dateFilterRange.from) || (0,isAfter/* default */.Z)(d, dateFilterRange.from) && (0,isBefore/* default */.Z)(d, dateFilterRange.to) || (d === null || d === void 0 ? void 0 : d.before) && (0,isAfter/* default */.Z)(d.before, dateFilterRange.from) // d.before is appended on the AddToCartSection
            ;
        })) {
            setRange(dateFilterRange);
            setTimeout(function() {
                onSubmit(dateFilterRange);
                setIsOpen(false);
            }, sleepTime);
        }
    };
    var handleSkipDatePickerPurchase = function() {
        if (!disabledDays.find(function(d) {
            return (0,isSameDay/* default */.Z)(d, purchaseRange.to) || (0,isSameDay/* default */.Z)(d, purchaseRange.from) || (0,isAfter/* default */.Z)(d, purchaseRange.from) && (0,isBefore/* default */.Z)(d, purchaseRange.to);
        })) {
            setRange(purchaseRange);
            setTimeout(function() {
                onSubmit(purchaseRange);
                setIsOpen(false);
            }, sleepTime);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        h: "100%",
        w: "100%",
        mt: "10px",
        children: [
            isPurchase && isLatestPastToday && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PurchaseDeliveryDate, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Icon, {
                        name: "tick_circle",
                        size: 32,
                        viewboxX: 16,
                        viewboxY: 16
                    }),
                    "This item is currently booked until ".concat(firstAvailableDate.toLocaleDateString("en-GB"), ". Your purchase will be checked and delivered after that booking")
                ]
            }),
            !dateFilterStartDate && !isPurchase && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                testingContext: "choose-dates-button",
                disabled: disabled,
                onClick: function() {
                    return disabled ? false : setIsOpen(true);
                },
                bgColor: "transparent",
                sx: {
                    "&:hover": disabled ? {
                        opacity: "0.4",
                        background: "#7182FF".concat(" !important")
                    } : undefined
                },
                children: defaultText
            }),
            dateFilterStartDate && !isPurchase && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                testingContext: "choose-dates-button",
                disabled: isDisabledPurchase || disabled,
                onClick: function() {
                    return handleSkipDatePicker();
                },
                children: defaultText
            }),
            isPurchase && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                testingContext: "choose-dates-button",
                disabled: disabled,
                onClick: function() {
                    return handleSkipDatePickerPurchase();
                },
                children: defaultText
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overlay.Overlay, {
                show: isOpen,
                hide: function() {
                    setIsOpen(false);
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                    m: "auto",
                    textAlign: "center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                            display: "flex",
                            justifyContent: "flex-end",
                            cursor: "pointer",
                            onClick: function() {
                                return setIsOpen(false);
                            },
                            pt: "1rem",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_svg_esm/* ReactSVG */.Q, {
                                src: x_black/* default.src */.Z.src
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                            __css: headerStyles,
                            mt: "1rem",
                            fontSize: "1.4rem",
                            children: "Pick your delivery date"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                            mt: "1rem",
                            maxWidth: "20rem",
                            mx: "auto",
                            children: samedayPickupEnabled ? "Pick a delivery or pickup date." : "Pick a delivery date 1-2 days before your event."
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckoutDatePicker, {
                            firstAvailableDate: firstAvailableDate,
                            disabledDays: disabledDays,
                            range: range,
                            handleOnDayClicked: handleOnDayClicked,
                            isSamedayEligible: samedayPickupEnabled,
                            canPickupToday: canPickupToday
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/AddToCartSection/AddToCartSectionDesignB/ProductVariantSelectorB/ProductVariantSelectorB.tsx








var ProductVariantSelectorB = function(param) {
    var productVariants = param.productVariants, setVariantId = param.setVariantId, variantId = param.variantId;
    var ref;
    var defaultRentalDayVariant = productVariants === null || productVariants === void 0 ? void 0 : productVariants.find(function(pv) {
        var _Math;
        if ((0,lodash.isEmpty)(productVariants) || !(pv === null || pv === void 0 ? void 0 : pv.rentalDays)) return null;
        return pv.rentalDays === (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(productVariants.map(function(pv2) {
            return (pv2 === null || pv2 === void 0 ? void 0 : pv2.rentalDays) || 0;
        })));
    });
    var defaultRentalDayGrossAmount = Number((0,lodash.get)(defaultRentalDayVariant, "pricing.price.gross.amount", 0));
    var defaultRentalDayBorrowerFee = Number((0,lodash.get)(defaultRentalDayVariant, "pricing.borrowerFee.gross.amount", 0));
    var defaultRentalDays = Number((0,lodash.get)(defaultRentalDayVariant, "rentalDays", 0));
    var rentalPriceOfDefaultRentalDayVariant = (defaultRentalDayGrossAmount + defaultRentalDayBorrowerFee) / defaultRentalDays;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
        width: "100%",
        alignItems: "left",
        children: (ref = productVariants === null || productVariants === void 0 ? void 0 : productVariants.sort(function(a, b) {
            return ((a === null || a === void 0 ? void 0 : a.rentalDays) || 0) - ((b === null || b === void 0 ? void 0 : b.rentalDays) || 0);
        })) === null || ref === void 0 ? void 0 : ref.map(function(pv, i) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            var itemRentDays = (pv === null || pv === void 0 ? void 0 : pv.rentalDays) || 0;
            var rentalPrice = (0,lodash.get)(pv, "pricing.price.gross.amount", 0) + (0,lodash.get)(pv, "pricing.borrowerFee.gross.amount", 0);
            var rentalPricePerDay = rentalPrice / itemRentDays;
            var rentalSavings = rentalPriceOfDefaultRentalDayVariant - rentalPricePerDay;
            // @ts-expect-error
            return (pv === null || pv === void 0 ? void 0 : pv.disabled) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                direction: "row",
                alignItems: "center",
                height: "30px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        width: "1.5rem",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Checkbox, {
                            name: (pv === null || pv === void 0 ? void 0 : pv.name) || "",
                            checked: (pv === null || pv === void 0 ? void 0 : pv.id) === variantId,
                            onChange: function() {
                                return setVariantId((pv === null || pv === void 0 ? void 0 : pv.id) || "");
                            },
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                        textAlign: "left",
                        style: {
                            fontSize: "1rem",
                            color: "red"
                        },
                        children: [
                            (pv === null || pv === void 0 ? void 0 : pv.name) || "",
                            " (",
                            "Unavailable for this date",
                            ") "
                        ]
                    })
                ]
            }, (pv === null || pv === void 0 ? void 0 : pv.id) || i) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Checkbox, {
                        marginBottomValue: 0.5,
                        name: (pv === null || pv === void 0 ? void 0 : pv.name) || "",
                        checked: (pv === null || pv === void 0 ? void 0 : pv.id) === variantId,
                        onChange: function() {
                            return setVariantId((pv === null || pv === void 0 ? void 0 : pv.id) || "");
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                            textAlign: "left",
                            style: {
                                fontSize: "1rem",
                                fontWeight: 600
                            },
                            children: [
                                (pv === null || pv === void 0 ? void 0 : pv.name) || "",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "span",
                                    sx: {
                                        fontWeight: "normal"
                                    },
                                    children: [
                                        " (",
                                        getProductPrice(null, pv === null || pv === void 0 ? void 0 : pv.pricing),
                                        ") "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Stack */.Kq, {
                        direction: "row",
                        alignItems: "center",
                        fontSize: "0.9rem",
                        ml: 10,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                children: [
                                    formatMoney(rentalPricePerDay, pv === null || pv === void 0 ? void 0 : (ref = pv.pricing) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.gross) === null || ref2 === void 0 ? void 0 : ref2.currency),
                                    "/day"
                                ]
                            }),
                            rentalSavings > 0 && (pv === null || pv === void 0 ? void 0 : pv.id) !== (defaultRentalDayVariant === null || defaultRentalDayVariant === void 0 ? void 0 : defaultRentalDayVariant.id) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                color: "green.500",
                                children: [
                                    "Save\xa0",
                                    formatMoney(rentalSavings, pv === null || pv === void 0 ? void 0 : (ref3 = pv.pricing) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.price) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.gross) === null || ref5 === void 0 ? void 0 : ref5.currency)
                                ]
                            })
                        ]
                    })
                ]
            }, pv === null || pv === void 0 ? void 0 : pv.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/AddToCartSection/AddToCartSectionDesignB/AddToCartSectionDesignB.tsx
/* eslint-disable import/no-unresolved */ 



























var AddToCartSectionDesignB_processProductVariants = function(productVariants, startDate, bookedDates) {
    if (!productVariants || productVariants.length === 0 || (0,lodash.isEmpty)(productVariants)) return [];
    var productVariantsModified = productVariants.map(function(param) {
        var id = param.id, sku = param.sku, name = param.name, rentalDays = param.rentalDays, quantityAvailable = param.quantityAvailable, images = param.images, pricing = param.pricing, attributes = param.attributes;
        var variantEndDate = null;
        var disabled = false;
        if (startDate) {
            variantEndDate = (0,addDays/* default */.Z)(startDate, rentalDays - 1);
            var varientEndDateString = variantEndDate === null || variantEndDate === void 0 ? void 0 : variantEndDate.toString();
            disabled = typeof varientEndDateString === "string" && bookedDates.some(function(date) {
                return date.toString() === varientEndDateString;
            });
        }
        if (rentalDays === 365) disabled = false;
        return {
            __typename: "ProductVariant",
            id: id,
            sku: sku,
            name: name,
            rentalDays: rentalDays,
            quantityAvailable: quantityAvailable,
            images: images,
            pricing: pricing,
            attributes: attributes,
            disabled: disabled
        };
    }).filter(function(param) {
        var name = param.name;
        return name !== "Purchase";
    }); // Removes the purchase variant;
    return productVariantsModified;
};
var AddToCartBoxes = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Stack */.Kq, {
        border: "1px solid",
        borderColor: globalStyles/* defaultTheme.colors.secondaryOverlayDark */.uH.colors.secondaryOverlayDark,
        p: 4,
        borderRadius: "md",
        width: "full",
        children: children
    });
};
var AddToCartSectionDesignB = function(param) {
    var availableForPurchase = param.availableForPurchase, isAvailableForPurchase = param.isAvailableForPurchase, items = param.items, name = param.name, designer = param.designer, designerSlug = param.designerSlug, bookedDates = param.bookedDates, product = param.product, productPricing = param.productPricing, productVariants = param.productVariants, productSeoDescription = param.productSeoDescription, productAttributes = param.productAttributes, onSubmit = param.onSubmit, setVariantId = param.setVariantId, variantId = param.variantId, mobile = param.mobile, removeItem = param.removeItem, productBookingsLoading = param.productBookingsLoading, _loaded = param.loaded, loaded = _loaded === void 0 ? false : _loaded, _isSamedayEligible = param.isSamedayEligible, isSamedayEligible = _isSamedayEligible === void 0 ? false : _isSamedayEligible, _canPickupToday = param.canPickupToday, canPickupToday = _canPickupToday === void 0 ? true : _canPickupToday;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var router = (0,next_router.useRouter)();
    var intl = (0,intl_shim/* useIntl */.YB)();
    var ref18 = (0,react.useState)(false), submitting = ref18[0], setSubmitting = ref18[1];
    var push = (0,DatalayerProvider/* useDatalayer */.t)().push;
    var currency = (0,react.useContext)(context/* ShopContext */.I).currency;
    var selectedVariant = productVariants === null || productVariants === void 0 ? void 0 : productVariants.find(function(pv) {
        return (pv === null || pv === void 0 ? void 0 : pv.id) === variantId;
    });
    var rentalPeriod = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.rentalDays;
    var preparationDays = product === null || product === void 0 ? void 0 : (ref = product.resource) === null || ref === void 0 ? void 0 : ref.preparationDays;
    var disabledDaysSortedAsc = bookedDates.sort(function(objA, objB) {
        return Number(objA) - Number(objB);
    });
    var today = new Date();
    // This is for the date where you can book the item
    var latestDate = !(0,lodash.isEmpty)(bookedDates) ? disabledDaysSortedAsc[disabledDaysSortedAsc.length - 1] : (0,add/* default */.Z)(today, {
        days: 1
    });
    latestDate = (0,add/* default */.Z)(latestDate, {
        days: preparationDays
    });
    // Reset the date to 12am
    latestDate.setHours(12, 0, 0, 0);
    var purchaseAvailableDate = !isAvailableForPurchase && availableForPurchase && Date.parse(availableForPurchase);
    var outOfStock = Number(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.quantityAvailable) <= 0;
    var maximumShippingDays = (0,lodash.get)(product, "shippingMethods[0].maximumDeliveryDays", 0);
    var minimumShippingDays = (0,lodash.get)(product, "shippingMethods[0].minimumDeliveryDays", 0);
    var disableButton = // eslint-disable-next-line strict-null-checks/all
    !canAddToCart(items || [], !!isAvailableForPurchase, variantId, 1) || outOfStock;
    var renderErrorMessage = function(message, testingContextId) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ErrorMessage */.Bc, {
            "data-test": "stockErrorMessage",
            "data-test-id": testingContextId,
            children: message
        });
    };
    var deliveryDate = router.query.deliveryDate;
    var ref19 = (0,react.useState)(deliveryDate && typeof deliveryDate === "string" ? new Date(deliveryDate) : null), startDate = ref19[0], setStartDate = ref19[1];
    startDate === null || startDate === void 0 ? void 0 : startDate.setHours(12, 0, 0, 0);
    if (startDate && startDate.getTime() > latestDate.getTime()) latestDate = startDate;
    var isLatestPastStartDate = startDate && latestDate.getTime() > startDate.getTime();
    var productVariantsModified = AddToCartSectionDesignB_processProductVariants(productVariants, startDate, bookedDates);
    var localeDateString = startDate === null || startDate === void 0 ? void 0 : startDate.toLocaleDateString("en-GB");
    var productSize = react.useMemo(function() {
        var ref;
        var productSizeStr = "";
        var productSizeAttr = productAttributes && (productAttributes === null || productAttributes === void 0 ? void 0 : productAttributes.length) > 0 && productAttributes.find(function(attr) {
            return attr.attribute.name === "Size";
        });
        if (productSizeAttr && (productSizeAttr === null || productSizeAttr === void 0 ? void 0 : (ref = productSizeAttr.values) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            productSizeStr = productSizeAttr.values.map(function(value) {
                return value === null || value === void 0 ? void 0 : value.name;
            }).join(", ");
        }
        return productSizeStr;
    }, [
        productAttributes
    ]);
    var hasIncompleteOrder = !submitting && items && items.length;
    var cartWarning = hasIncompleteOrder ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_alert_esm/* Alert */.bZ, {
                status: "error",
                paddingY: "16px",
                paddingX: "12px",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                    display: "flex",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            marginBottom: "5px",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* AlertIcon */.zM, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_alert_esm/* AlertIcon */.zM, {})
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_alert_esm/* AlertTitle */.Cd, {
                                    children: "Only one item can be ordered at a time."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_alert_esm/* AlertDescription */.X, {
                            children: "Complete the order for the ".concat(name, " or remove it from your bag.")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(atoms.ButtonBoxLink, {
                style: {
                    fontSize: "1rem",
                    lineHeight: "1.1rem",
                    marginTop: "10px",
                    marginBottom: "10px",
                    width: "100%",
                    height: "56px",
                    gap: "5px",
                    background: "black",
                    color: "white"
                },
                href: paths/* paths.checkout */.H.checkout,
                testingContext: "complete-current-order-btn",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* BagIcon */.Ln, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Icon, {
                            name: "cart",
                            size: 24,
                            viewboxX: 32,
                            viewboxY: 32
                        })
                    }),
                    "COMPLETE ORDER"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(atoms.Button, {
                style: {
                    whiteSpace: "normal",
                    height: "40px",
                    padding: "8px",
                    fontSize: "1rem",
                    lineHeight: "1.1rem",
                    textTransform: "unset",
                    marginBottom: "10px",
                    width: "100%",
                    gap: "5px"
                },
                testingContext: "clearCartButton",
                onClick: function() {
                    return removeItem(items[0].variant.id);
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* RemoveIcon */.HF, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Icon, {
                            name: "trash",
                            size: 24,
                            viewboxX: 32,
                            viewboxY: 32
                        })
                    }),
                    "REMOVE FROM BAG"
                ]
            })
        ]
    }) : null;
    var isRental = (rentalPeriod || 0) < 365;
    var dateSelectText = "RENT NOW";
    if (outOfStock) dateSelectText = "OUT OF STOCK";
    if (!isRental) dateSelectText = "BUY NOW";
    var changeDateText = mobile ? "CHANGE DELIVERY DATE" : "Change delivery date";
    var deliveryText = isRental ? "Renting for a delivery date of ".concat(localeDateString) : "Purchasing for a delivery date of ".concat(latestDate.toLocaleDateString("en-GB"));
    var purchaseVariant = productVariants === null || productVariants === void 0 ? void 0 : productVariants.find(function(productPurchaseVariant) {
        return (productPurchaseVariant === null || productPurchaseVariant === void 0 ? void 0 : productPurchaseVariant.name) === "Purchase";
    });
    var productRetailValue = Number(product === null || product === void 0 ? void 0 : (ref1 = product.retailValue) === null || ref1 === void 0 ? void 0 : ref1.amount);
    var productPurchasePrice = Number(purchaseVariant === null || purchaseVariant === void 0 ? void 0 : (ref2 = purchaseVariant.pricing) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.gross) === null || ref4 === void 0 ? void 0 : ref4.amount) + Number(purchaseVariant === null || purchaseVariant === void 0 ? void 0 : (ref5 = purchaseVariant.pricing) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.borrowerFee) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.gross) === null || ref7 === void 0 ? void 0 : ref7.amount);
    var retailSavings = productRetailValue - productPurchasePrice;
    var originalPurchasePrice = product === null || product === void 0 ? void 0 : (ref8 = product.originalPurchasePrice) === null || ref8 === void 0 ? void 0 : ref8.amount;
    var moneySaved = 0;
    if (originalPurchasePrice && productPurchasePrice && originalPurchasePrice > productPurchasePrice && product.hasWarehouseSale) {
        moneySaved = originalPurchasePrice - productPurchasePrice;
    }
    var pushToDataLayer = function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var ref6;
        var selectedVariantPrice = (ref6 = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.pricing) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.gross) === null || ref2 === void 0 ? void 0 : ref2.amount) !== null && ref6 !== void 0 ? ref6 : 0;
        var ref7;
        var borrowerFee = (ref7 = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref3 = selectedVariant.pricing) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.borrowerFee) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.gross) === null || ref5 === void 0 ? void 0 : ref5.amount) !== null && ref7 !== void 0 ? ref7 : 0;
        var totalPrice = selectedVariantPrice + borrowerFee;
        if (product && selectedVariant && !!totalPrice) {
            var ref8;
            var ref9;
            push({
                event: "add_to_cart",
                ecommerce: {
                    currency: currency,
                    value: totalPrice,
                    items: [
                        {
                            item_id: (0,base64/* decodeBase64Id */.n)(product.id),
                            item_brand: (0,getAttributeValue/* getAttributeValue */.k)("designer", product.attributes),
                            item_category: (ref9 = (ref8 = product.category) === null || ref8 === void 0 ? void 0 : ref8.name) !== null && ref9 !== void 0 ? ref9 : "",
                            item_name: product.name,
                            item_variant: "Size ".concat((0,getAttributeValue/* getAttributeValue */.k)("size", product.attributes)),
                            price: totalPrice,
                            quantity: 1
                        }, 
                    ]
                }
            });
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                gap: {
                    base: 0,
                    ml: 2
                },
                alignItems: "flex-start",
                mt: {
                    base: 4,
                    lg: 0
                },
                mb: 12,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* DesignerHeader */.$c, {
                        "data-test": "designer",
                        href: "/designers/".concat(designerSlug.endsWith("-hire") ? designerSlug : designerSlug.concat("-hire")),
                        children: [
                            designer,
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* ChevronRightIcon */.XC, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Heading */.X6, {
                        as: "h1",
                        "data-test": "productName",
                        fontSize: {
                            base: 20,
                            md: 24
                        },
                        children: name
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: 16,
                        "data-test": "productSize",
                        children: [
                            "Size ",
                            productSize
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                width: "full",
                gap: 6,
                w: "full",
                maxW: "65ch",
                margin: "0 auto",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AddToCartBoxes, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Heading */.X6, {
                                as: "h2",
                                fontSize: {
                                    base: 18,
                                    md: 20
                                },
                                justifyContent: "start",
                                display: "flex",
                                alignItems: "center",
                                children: [
                                    !!productPricing && getProductPrice(productPricing, purchaseVariant === null || purchaseVariant === void 0 ? void 0 : purchaseVariant.pricing),
                                    " ",
                                    moneySaved && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                style: {
                                                    fontSize: 15,
                                                    color: "grey",
                                                    textDecoration: "line-through",
                                                    marginLeft: 5
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* Money */.W, {
                                                    money: {
                                                        amount: product === null || product === void 0 ? void 0 : (ref9 = product.originalPurchasePrice) === null || ref9 === void 0 ? void 0 : ref9.amount,
                                                        currency: (product === null || product === void 0 ? void 0 : (ref10 = product.originalPurchasePrice) === null || ref10 === void 0 ? void 0 : ref10.currency) || ""
                                                    },
                                                    showDecimals: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                style: {
                                                    fontSize: 15,
                                                    color: "#d7362c",
                                                    marginLeft: 5
                                                },
                                                children: [
                                                    "(",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, {
                                                        defaultMessage: "Save"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* Money */.W, {
                                                        money: {
                                                            amount: moneySaved,
                                                            currency: (product === null || product === void 0 ? void 0 : (ref11 = product.originalPurchasePrice) === null || ref11 === void 0 ? void 0 : ref11.currency) || ""
                                                        },
                                                        showDecimals: true
                                                    }),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                sx: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                fontSize: {
                                    base: 12,
                                    md: 14
                                },
                                color: "#a1a1a1",
                                children: [
                                    "or 4 payments of\xa0",
                                    !!productPricing && getAfterpayPrice(productPricing, purchaseVariant === null || purchaseVariant === void 0 ? void 0 : purchaseVariant.pricing),
                                    "\xa0with\xa0",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        src: afterpay.src,
                                        width: 80,
                                        height: 35,
                                        alt: "afterpay-logo"
                                    })
                                ]
                            }),
                            !(0,lodash.isNaN)(productRetailValue) && retailSavings > 1 && !moneySaved ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                fontSize: 14,
                                gap: 2,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                        children: [
                                            "Retail:\xa0",
                                            formatMoney(productRetailValue, purchaseVariant === null || purchaseVariant === void 0 ? void 0 : (ref12 = purchaseVariant.pricing) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.price) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.gross) === null || ref14 === void 0 ? void 0 : ref14.currency)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                        color: "green.500",
                                        children: [
                                            "Save\xa0",
                                            formatMoney(retailSavings, purchaseVariant === null || purchaseVariant === void 0 ? void 0 : (ref15 = purchaseVariant.pricing) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.price) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.gross) === null || ref17 === void 0 ? void 0 : ref17.currency)
                                        ]
                                    })
                                ]
                            }) : null,
                            !productBookingsLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* VariantPickerB */.FC, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckoutButton, {
                                    isPurchase: true,
                                    defaultText: "BUY NOW",
                                    disabledDays: (0,_to_consumable_array/* default */.Z)(bookedDates).concat([
                                        !isSamedayEligible ? {
                                            before: dayjs_min_default()().startOf("date").add(2, "day").toDate()
                                        } : canPickupToday ? {
                                            before: dayjs_min_default()().startOf("date").toDate()
                                        } : {
                                            before: dayjs_min_default()().startOf("date").add(1, "day").toDate()
                                        }, 
                                    ]),
                                    dateFilterStartDate: startDate || undefined,
                                    daysRange: (purchaseVariant === null || purchaseVariant === void 0 ? void 0 : purchaseVariant.rentalDays) || 365,
                                    disabled: !(purchaseVariant === null || purchaseVariant === void 0 ? void 0 : purchaseVariant.rentalDays) || disableButton,
                                    onSubmit: function() {
                                        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                                            var from, to;
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        from = param.from, to = param.to;
                                                        if (!(purchaseVariant === null || purchaseVariant === void 0 ? void 0 : purchaseVariant.id)) return [
                                                            2
                                                        ];
                                                        setSubmitting(true);
                                                        pushToDataLayer();
                                                        return [
                                                            4,
                                                            onSubmit({
                                                                variantId: purchaseVariant.id,
                                                                quantity: 1,
                                                                rentalPeriod: purchaseVariant.rentalDays,
                                                                bookedRange: {
                                                                    from: from,
                                                                    to: to
                                                                }
                                                            })
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(_) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(),
                                    sleepTime: 500,
                                    preparationDays: preparationDays || 3,
                                    maximumShippingDays: maximumShippingDays,
                                    minimumShippingDays: minimumShippingDays,
                                    samedayPickupEnabled: isSamedayEligible,
                                    canPickupToday: canPickupToday
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AddToCartBoxes, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Heading */.X6, {
                                as: "h2",
                                fontSize: {
                                    base: 18,
                                    md: 20
                                },
                                children: "Rent this Item"
                            }),
                            deliveryDate && isRental && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* DeliveryDate */.PP, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Icon, {
                                        name: "tick_circle",
                                        size: 20,
                                        viewboxX: 16,
                                        viewboxY: 16
                                    }),
                                    deliveryText
                                ]
                            }),
                            deliveryDate && !isRental && !isLatestPastStartDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* DeliveryDate */.PP, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Icon, {
                                        name: "tick_circle",
                                        size: 20,
                                        viewboxX: 16,
                                        viewboxY: 16
                                    }),
                                    deliveryText
                                ]
                            }),
                            purchaseAvailableDate && renderErrorMessage(intl.formatMessage(src_intl/* commonMessages.purchaseAvailableOn */.i4.purchaseAvailableOn), "timeRestrictedAvailability"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ProductDescription */.vI, {
                                        "data-test": "productDescription",
                                        children: productSeoDescription
                                    }),
                                    !hasIncompleteOrder && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductVariantSelectorB, {
                                                productVariants: productVariantsModified,
                                                variantId: variantId,
                                                setVariantId: setVariantId
                                            }),
                                            !productBookingsLoading && loaded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* VariantPickerB */.FC, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckoutButton, {
                                                    disabledDays: (0,_to_consumable_array/* default */.Z)(bookedDates).concat([
                                                        !isSamedayEligible ? {
                                                            before: dayjs_min_default()().startOf("date").add(2, "day").toDate()
                                                        } : canPickupToday ? {
                                                            before: dayjs_min_default()().startOf("date").toDate()
                                                        } : {
                                                            before: dayjs_min_default()().startOf("date").add(1, "day").toDate()
                                                        }, 
                                                    ]),
                                                    dateFilterStartDate: startDate || undefined,
                                                    daysRange: rentalPeriod || 3,
                                                    disabled: !rentalPeriod || disableButton,
                                                    onSubmit: function() {
                                                        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                                                            var from, to;
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        from = param.from, to = param.to;
                                                                        setSubmitting(true);
                                                                        pushToDataLayer();
                                                                        return [
                                                                            4,
                                                                            onSubmit({
                                                                                variantId: variantId,
                                                                                quantity: 1,
                                                                                rentalPeriod: rentalPeriod,
                                                                                bookedRange: {
                                                                                    from: from,
                                                                                    to: to
                                                                                }
                                                                            })
                                                                        ];
                                                                    case 1:
                                                                        _state.sent();
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                        return function(_) {
                                                            return _ref.apply(this, arguments);
                                                        };
                                                    }(),
                                                    defaultText: dateSelectText,
                                                    sleepTime: 500,
                                                    isPurchase: false,
                                                    preparationDays: preparationDays || 3,
                                                    maximumShippingDays: maximumShippingDays,
                                                    minimumShippingDays: minimumShippingDays,
                                                    samedayPickupEnabled: isSamedayEligible,
                                                    canPickupToday: canPickupToday
                                                })
                                            })
                                        ]
                                    }),
                                    !hasIncompleteOrder && deliveryDate && isRental && !productBookingsLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ChangeDatePickerB */.Jk, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckoutButton, {
                                            disabledDays: (0,_to_consumable_array/* default */.Z)(bookedDates).concat([
                                                !isSamedayEligible ? {
                                                    before: dayjs_min_default()().startOf("date").add(2, "day").toDate()
                                                } : canPickupToday ? {
                                                    before: dayjs_min_default()().startOf("date").toDate()
                                                } : {
                                                    before: dayjs_min_default()().startOf("date").add(1, "day").toDate()
                                                }, 
                                            ]),
                                            daysRange: rentalPeriod || 3,
                                            disabled: !rentalPeriod || disableButton,
                                            onSubmit: function(param) {
                                                var from = param.from;
                                                setStartDate(from);
                                            },
                                            defaultText: changeDateText,
                                            sleepTime: 500,
                                            preparationDays: preparationDays || 3,
                                            maximumShippingDays: maximumShippingDays,
                                            minimumShippingDays: minimumShippingDays,
                                            samedayPickupEnabled: isSamedayEligible,
                                            canPickupToday: canPickupToday
                                        })
                                    }),
                                    cartWarning
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                fontSize: "0.9rem",
                                textAlign: "left",
                                children: "The Lender will receive your request and has 24 hours to accept or decline it. The Volte will notify you via email and SMS."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/AddToCartSection/index.tsx




/***/ }),

/***/ 60640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$c": function() { return /* binding */ DesignerHeader; },
/* harmony export */   "Bc": function() { return /* binding */ ErrorMessage; },
/* harmony export */   "C7": function() { return /* binding */ AfterPay; },
/* harmony export */   "FC": function() { return /* binding */ VariantPickerB; },
/* harmony export */   "FM": function() { return /* binding */ RentButton; },
/* harmony export */   "HF": function() { return /* binding */ RemoveIcon; },
/* harmony export */   "Jk": function() { return /* binding */ ChangeDatePickerB; },
/* harmony export */   "Ln": function() { return /* binding */ BagIcon; },
/* harmony export */   "PP": function() { return /* binding */ DeliveryDate; },
/* harmony export */   "aH": function() { return /* binding */ AddToCartSelection; },
/* harmony export */   "dy": function() { return /* binding */ ChangeDatePicker; },
/* harmony export */   "ez": function() { return /* binding */ UndiscountedPrice; },
/* harmony export */   "fH": function() { return /* binding */ VariantPicker; },
/* harmony export */   "go": function() { return /* binding */ ProductPricing; },
/* harmony export */   "ox": function() { return /* binding */ ProductNameHeader; },
/* harmony export */   "qA": function() { return /* binding */ PickBoxes; },
/* harmony export */   "vH": function() { return /* binding */ ProductSizeHeader; },
/* harmony export */   "vI": function() { return /* binding */ ProductDescription; },
/* harmony export */   "zM": function() { return /* binding */ AlertIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16829);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63319);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        padding-top: 0;\n        padding-bottom: 0.5rem;\n        font-size: 16px;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-size: 16px;\n      color: #71797e;\n      font-weight: ",
        ";\n      padding-top: ",
        ";\n      text-align: left;\n\n      &:hover {\n        color: ",
        ";\n      }\n\n      svg {\n        color: ",
        ";\n        font-size: 28px;\n        margin-top: -3px;\n        font-weight: 100;\n      }\n\n      ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        padding-top: 0;\n        font-size: ",
        ";\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      text-transform: uppercase;\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      padding-top: ",
        ";\n      text-align: left;\n\n      ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-size: ",
        ";\n      margin-top: 5px;\n      margin-bottom: 27px;\n      text-align: left;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-weight: ",
        ";\n      margin-bottom: 5px;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 5px;\n      font-size: ",
        ";\n      margin-bottom: 16px;\n      padding: 12px;\n      background-color: ",
        ";\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-size: ",
        ";\n      margin-bottom: ",
        ";\n      color: #a1a1a1;\n      display: flex;\n      align-items: center;\n      gap: 5px;\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        display: block;\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-size: ",
        ";\n      margin-bottom: ",
        ";\n      display: none;\n\n      ",
        ";\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      text-decoration: line-through;\n      color: ",
        ";\n      font-size: ",
        ";\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: grid;\n      margin-top: 20px;\n      width: 280px;\n      justify-items: start;\n\n      .react-select-wrapper,\n      .input {\n        width: 75%;\n        margin-bottom: ",
        ";\n      }\n\n      .chakra-button {\n        height: 45px;\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        width: 100%;\n      }\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: grid;\n      margin-top: 20px;\n      width: 280px;\n      justify-items: start;\n\n      .react-select-wrapper,\n      .input {\n        width: 75%;\n        margin-bottom: ",
        ";\n      }\n\n      .chakra-button {\n        height: auto;\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        width: 100%;\n        border: none;\n        justify-items: start;\n        padding: 0;\n        text-decoration: underline;\n      }\n\n      .chakra-button:hover {\n        background-color: white;\n        color: blue;\n        text-decoration: underline;\n      }\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 100%;\n\n      .react-select-wrapper,\n      .input {\n        width: 75%;\n        margin-bottom: ",
        ";\n      }\n\n      .chakra-button {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        width: 100%;\n      }\n    "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 100%;\n\n      .react-select-wrapper,\n      .input {\n        width: 75%;\n        margin-bottom: ",
        ";\n      }\n\n      .chakra-button {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        width: 100%;\n        border: none;\n        padding: 0;\n        text-decoration: underline;\n      }\n\n      .chakra-button:hover {\n        background-color: white;\n        color: blue;\n        text-decoration: underline;\n      }\n    "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      .chakra-button {\n        height: 100%;\n        font-weight: ",
        ";\n      }\n\n      input {\n        padding: 0.3rem 1rem;\n      }\n    "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-left: 10px;\n      margin-right: 10px;\n\n      .chakra-button {\n        width: 100%;\n        height: 48px;\n        font-weight: ",
        ";\n        border-radius: 8px;\n      }\n    "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  path {\n    fill: white;\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  path {\n    fill: black;\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n\n  svg {\n    height: 24px;\n    width: 24px;\n  }\n\n  span {\n    height: 24px;\n    width: 24px;\n  }\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}



var AddToCartSelection = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject());
var DesignerHeader = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a */ .Z.a(_templateObject3(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, space = theme.space;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), typography.extraBoldFontWeight, space[3], theme.colors.tertiaryLight, theme.colors.tertiaryLight, _styles__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject1()));
});
var ProductNameHeader = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h1 */ .Z.h1(_templateObject6(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, space = theme.space;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), typography.h4FontSize, typography.extraBoldFontWeight, space[3], _styles__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject4(), typography.baseFontSize));
});
var ProductSizeHeader = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3 */ .Z.h3(_templateObject8(), function(param) {
    var theme = param.theme;
    var typography = theme.typography;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), typography.h4FontSize);
});
var ProductPricing = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4 */ .Z.h4(_templateObject10(), function(param) {
    var theme = param.theme;
    var typography = theme.typography;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), typography.boldFontWeight);
});
var DeliveryDate = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4 */ .Z.h4(_templateObject12(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, colors = theme.colors;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject11(), typography.smallFontSize, colors.successGreen);
});
var AfterPay = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p */ .Z.p(_templateObject14(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, spacing = theme.spacing;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject13(), typography.smallFontSize, spacing.spacer);
});
var ProductDescription = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p */ .Z.p(_templateObject17(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, spacing = theme.spacing;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject16(), typography.smallFontSize, spacing.spacer, _styles__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject15()));
});
var UndiscountedPrice = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span(_templateObject19(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, colors = theme.colors;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject18(), colors.baseFontColorSemiTransparent, typography.smallFontSize);
});
var VariantPicker = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject21(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, spacing = theme.spacing;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject20(), spacing.spacer, theme.typography.baseFontSize, typography.extraBoldFontWeight);
});
var ChangeDatePicker = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject23(), function(param) {
    var theme = param.theme;
    var spacing = theme.spacing, typography = theme.typography;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject22(), spacing.spacer, theme.typography.baseFontSize, typography.extraBoldFontWeight);
});
var VariantPickerB = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject25(), function(param) {
    var theme = param.theme;
    var typography = theme.typography, spacing = theme.spacing;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject24(), spacing.spacer, theme.typography.baseFontSize, typography.extraBoldFontWeight);
});
var ChangeDatePickerB = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject27(), function(param) {
    var theme = param.theme;
    var spacing = theme.spacing, typography = theme.typography;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject26(), spacing.spacer, theme.typography.baseFontSize, typography.extraBoldFontWeight);
});
var ErrorMessage = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p */ .Z.p(_templateObject28(), function(props) {
    return props.theme.colors.error;
});
// export const PickBoxes = styled.div`
//   .chakra-button {
//     height: 100%;
//     font-weight: ${typography.extraBoldFontWeight};
//   }
//   input {
//     padding: 0.3rem 1rem;
//   }
// `;
var PickBoxes = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject30(), function(param) {
    var theme = param.theme;
    var typography = theme.typography;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject29(), typography.extraBoldFontWeight);
});
var RentButton = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject32(), function(param) {
    var theme = param.theme;
    var typography = theme.typography;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject31(), typography.extraBoldFontWeight);
});
var BagIcon = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject33());
var RemoveIcon = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject34());
var AlertIcon = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject35());


/***/ }),

/***/ 92971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Overlay": function() { return /* reexport */ Overlay_Overlay; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 2 modules
var Transition = __webpack_require__(8662);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/components/organisms/Overlay/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n      transform: translateX(",
        ");\n    }\n    to {\n      transform: translateX(",
        ");\n    }"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ",
        ": 0;\n        transform: translateX(",
        ");\n        animation: ",
        " 0.4s both;\n        animation-delay: ",
        ";\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  width: ",
        ";\n  min-height: ",
        "px;\n  height: ",
        ";\n  background-color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: fixed;\n  overflow-y: auto;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  z-index: ",
        ";\n  transition: opacity 0.2s ease;\n  transition-delay: ",
        ";\n  background-color: ",
        ";\n  align-items: center;\n  justify-content: ",
        ";\n  opacity: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var getTranslate = function(side) {
    return side === "left" ? "-100%" : "100%";
};
var slideAnimation = function(open, side) {
    var initialValue = open ? getTranslate(side) : 0;
    var endValue = open ? 0 : getTranslate(side);
    return (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject(), initialValue, endValue);
};
var opacity = {
    entered: 1,
    entering: 0,
    exited: 0,
    exiting: 0,
    unmounted: 0
};
var justify = {
    center: "center",
    left: "flex-start",
    right: "flex-end"
};
var lightboxWidth = {
    center: "auto",
    left: "100%",
    right: "100%"
};
var lightboxHeight = function(width) {
    return {
        center: "".concat(width, "px"),
        left: "auto",
        right: "auto"
    };
};
var Lightbox = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2(), function(param) {
    var position = param.position, modal = param.theme.modal;
    return lightboxHeight(modal.modalWidth)[position];
}, function(props) {
    return props.theme.modal.modalMinHeight;
}, function(param) {
    var position = param.position;
    return lightboxWidth[position];
}, function(props) {
    return props.opacity ? props.theme.colors.whiteSlightlyTransparent : props.theme.colors.white;
}, function(param) {
    var open = param.open, position = param.position;
    if (position === "left" || position === "right") {
        return (0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), position, getTranslate(position), slideAnimation(open, position), open ? ".1s" : 0);
    }
});
Lightbox.displayName = "S.Lightbox";
var Overlay = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3(), constants/* Z_INDEX_OVERLAY */.VT, function(param) {
    var open = param.open;
    return open ? 0 : ".4s";
}, function(param) {
    var transparent = param.transparent, theme = param.theme;
    return transparent ? "" : theme.colors.overlay;
}, function(param) {
    var position = param.position;
    return justify[position];
}, function(param) {
    var state = param.state;
    return opacity[state];
});
Overlay.displayName = "S.Overlay";

;// CONCATENATED MODULE: ./src/components/organisms/Overlay/Overlay.tsx







var Overlay_Overlay = function(param) {
    var children = param.children, _duration = param.duration, duration = _duration === void 0 ? 600 : _duration, hide = param.hide, _position = param.position, position = _position === void 0 ? "center" : _position, show = param.show, _transparent = param.transparent, transparent = _transparent === void 0 ? false : _transparent, target = param.target, testingContext = param.testingContext, testingContextId = param.testingContextId, _lightboxOpacity = param.lightboxOpacity, lightboxOpacity = _lightboxOpacity === void 0 ? false : _lightboxOpacity;
    var ref = (0,react.useState)(target || document.getElementById("modal-root")), portalTarget = ref[0], setPortalTarget = ref[1];
    var animationProps = {
        open: show,
        position: position,
        opacity: lightboxOpacity
    };
    (0,react.useEffect)(function() {
        if (target) {
            setPortalTarget(target);
        }
    }, [
        target
    ]);
    return portalTarget && /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Transition/* default */.ZP, {
        in: show,
        timeout: duration,
        unmountOnExit: true,
        children: function(state) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overlay, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animationProps), {
                state: state,
                onClick: hide,
                transparent: transparent,
                "data-test": testingContext,
                "data-test-id": testingContextId,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Lightbox, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animationProps), {
                    state: state,
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    children: children
                }))
            }));
        }
    }), portalTarget);
};

;// CONCATENATED MODULE: ./src/components/organisms/Overlay/index.ts



/***/ }),

/***/ 78166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useFirstAvailableDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50415);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81743);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42699);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(313);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77349);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var isDateDisabled = function(disabledDays, currentDate, range) {
    if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(disabledDays)) return false;
    // Define the start and end dates of the purchase period
    var purchaseStart = currentDate;
    var purchaseEnd = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(currentDate, {
        days: range
    });
    // Check if any disabled day falls within the purchase period
    return disabledDays.some(function(disabledDay) {
        return (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(disabledDay, purchaseStart) || (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(disabledDay, purchaseEnd) || (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(disabledDay, purchaseStart) && (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(disabledDay, purchaseEnd);
    });
};
/**
 * useFirstAvailableDate is used on AddToCartSection where it calculates the booking date of an item for checkout
 */ var useFirstAvailableDate = function(param) {
    var disabledDays = param.disabledDays, preparationDays = param.preparationDays, maximumShippingDays = param.maximumShippingDays, minimumShippingDays = param.minimumShippingDays, validRange = param.validRange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(new Date()), firstAvailableDate = ref[0], setFirstAvailableDate = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(new Date()), firstAvailablePurchaseDateEnd = ref1[0], setFirstAvailablePurchaseDateEnd = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isDisabledPurchase = ref2[0], setIsDisabledPurchase = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var maxIterationDateCount = 365;
        var iterationDateCount = 0;
        var currentDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new Date(), preparationDays);
        currentDate.setHours(12, 0, 0, 0);
        while(isDateDisabled(disabledDays, currentDate, validRange) && iterationDateCount < maxIterationDateCount){
            currentDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(currentDate, 1);
            ++iterationDateCount;
        }
        var availableDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(currentDate, maximumShippingDays + minimumShippingDays);
        var availablePurchaseEndDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(availableDate, validRange);
        setFirstAvailableDate(availableDate);
        setFirstAvailablePurchaseDateEnd(availablePurchaseEndDate);
        var isPurchaseDisabled = disabledDays.some(function(d) {
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(d, availablePurchaseEndDate) || (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(d, availableDate) || (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(d, availableDate) && (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(d, availablePurchaseEndDate);
        });
        setIsDisabledPurchase(isPurchaseDisabled);
    }, [
        disabledDays,
        preparationDays,
        maximumShippingDays,
        minimumShippingDays,
        validRange, 
    ]);
    var resetDate = function() {
        setFirstAvailableDate(new Date());
        setFirstAvailablePurchaseDateEnd(new Date());
        setIsDisabledPurchase(false);
    };
    return {
        firstAvailableDate: firstAvailableDate,
        firstAvailablePurchaseDateEnd: firstAvailablePurchaseDateEnd,
        isDisabledPurchase: isDisabledPurchase,
        resetDate: resetDate
    };
};


/***/ }),

/***/ 6360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ getAttributeValue; }
/* harmony export */ });
var getAttributeValue = function(attrName, attributes) {
    var ref, ref1, ref2;
    if (!attributes) return "";
    var ref3;
    return (ref3 = (ref = attributes.find(function(attr) {
        return attr.attribute.slug === attrName;
    })) === null || ref === void 0 ? void 0 : (ref1 = ref.values) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name) !== null && ref3 !== void 0 ? ref3 : "";
};


/***/ })

}]);